"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTypeToJSON = exports.QuestionTypeFromJSONTyped = exports.QuestionTypeFromJSON = exports.QuestionType = void 0;
/**
 * the type of question being asked
 * @export
 */
exports.QuestionType = {
    PersonIndication: 'person_indication',
    PersonIndicationAgeOfOnset: 'person_indication_age_of_onset',
    PersonIndicationAttribute: 'person_indication_attribute',
    PersonField: 'person_field',
    ExistenceQuestion: 'existence_question',
    RelativeRelation: 'relative_relation'
};
function QuestionTypeFromJSON(json) {
    return QuestionTypeFromJSONTyped(json, false);
}
exports.QuestionTypeFromJSON = QuestionTypeFromJSON;
function QuestionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.QuestionTypeFromJSONTyped = QuestionTypeFromJSONTyped;
function QuestionTypeToJSON(value) {
    return value;
}
exports.QuestionTypeToJSON = QuestionTypeToJSON;
